import React from "react";
import {Form, Input, Modal} from "antd";
import {FormModalProps} from "../../../../utils/useFormModal";
import Select from "../../../../components/Select";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'name'} label={'快递名称'} rules={[{required: true, message: '请输入快递名称'}]}>
                    <Select url={'/base/getExpresses'} getData={data => data.data} textField={'name'}
                            valueField={'name'}/>
                </Form.Item>
                <Form.Item name={'externalName'} label={'外部快递名称'}
                           rules={[{required: true, message: '请输入外部快递名称'}]}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'externalKey'} label={'外部快递Key'}
                           rules={[{required: true, message: '请输入外部快递Key'}]}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal;
